import { css } from '@emotion/css';
import colors from '@/theme/colors';

const styles = {
  flyerRemovedPage: css`
    display: flex;
    flex-flow: column nowrap;
    min-height: 100vh;
  `,
  flyerRemovedContainer: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media (max-width: 480px) {
      img {
        width: 100%;
        height: auto;
      }
    }
  `,
  flyerRemovedButton: css`
    padding-top: 37px;
    z-index: 9999999;
  `,
  flyerRemovedBottom: css`
    z-index: 9999999;
  `,
};

export default styles;
